import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getUniqueId } from 'hooks/useUniqueId';
import { TEAM_ICONS } from 'utils/icons';
import { useFetchTeams } from 'actions/team';
import InlineList from 'components/InlineList';
import { AdminPill, EveryonePill, TeamPill } from 'components/Pill';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Box from 'components/Box';
import DetailsDropdown from 'components/ContentInfo/DropdownInfo';
import Icon from 'components/Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function AudienceList(_ref) {
  var titleId = _ref.titleId,
    teams = _ref.teams,
    audienceType = _ref.audienceType;
  if (audienceType === 'all') {
    return /*#__PURE__*/_jsx(EveryonePill, {});
  }
  if (audienceType === 'admin') {
    return /*#__PURE__*/_jsx(AdminPill, {});
  }
  return /*#__PURE__*/_jsx(InlineList, {
    spacing: "xxs",
    "aria-labelledby": titleId,
    children: teams.map(function (team) {
      return /*#__PURE__*/_jsx(TeamPill, {
        team: team
      }, team.id);
    })
  });
}
function PermissionWidget(_ref2) {
  var contentPermissions = _ref2.contentPermissions;
  var titleId = getUniqueId();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var teamIds = (contentPermissions === null || contentPermissions === void 0 ? void 0 : contentPermissions.flatMap(function (content) {
    return content.teamIds;
  })) || [];
  var _useFetchTeams = useFetchTeams({
      teamIds: teamIds
    }),
    teams = _useFetchTeams.items;
  var playlistsAndTeams = contentPermissions === null || contentPermissions === void 0 ? void 0 : contentPermissions.map(function (content) {
    var teamIds = content.teamIds;
    var contentTeams = teams.filter(function (team) {
      return teamIds.includes(team.id);
    });
    return /*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [/*#__PURE__*/_jsx(Text, {
        bold: true,
        as: "h2",
        id: titleId,
        children: content.name
      }), /*#__PURE__*/_jsx(AudienceList, {
        titleId: titleId,
        teams: contentTeams,
        audienceType: content.audienceType
      })]
    }, content.id);
  });
  if (!playlistsAndTeams || playlistsAndTeams.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(Box, {
    as: "span",
    fontSize: "s",
    children: /*#__PURE__*/_jsxs(DetailsDropdown, {
      listLayout: "stack",
      titleKey: 'actions_view_who_has_access',
      listItems: playlistsAndTeams,
      children: [/*#__PURE__*/_jsx(Icon, {
        name: TEAM_ICONS.TEAM,
        mr: "xxs"
      }), t('actions_view_who_has_access')]
    })
  });
}
export default PermissionWidget;